export const SUBMISSION_CHANGE_ORDER_ERROR = "SUBMISSION_CHANGE_ORDER_ERROR";
export const SUBMISSION_ERROR_ROW = "SUBMISSION_ERROR_ROW";
export const SUBMISSION_FORM_DATA_FETCH_ERROR =
  "SUBMISSION_FORM_DATA_FETCH_ERROR";
export const SUBMISSION_PROCESS_LOG_UPDATE_ERROR =
  "SUBMISSION_PROCESS_LOG_UPDATE_ERROR";
export const SUBMISSION_ERROR_LIST_REQUEST = "SUBMISSION_ERROR_LIST_REQUEST";
export const SUBMISSION_ERROR_LIST_ERROR = "SUBMISSION_ERROR_LIST_ERROR";
export const SUBMISSION_ERROR_LIST_SUCCESS = "SUBMISSION_ERROR_LIST_SUCCESS";
export const SUBMISSION_SEND_TEMPLATE_CONFIRM_MODAL_CLOSE =
  "SUBMISSION_SEND_TEMPLATE_CONFIRM_MODAL_CLOSE";
export const SUBMISSION_SEND_TEMPLATE_DEVICE_ERROR =
  "SUBMISSION_SEND_TEMPLATE_DEVICE_ERROR";
export const SUBMISSION_SEND_TEMPLATE_DEVICE_REQUEST =
  "SUBMISSION_SEND_TEMPLATE_DEVICE_REQUEST";
export const SUBMISSION_SEND_TEMPLATE_DEVICE_SUCCESS =
  "SUBMISSION_SEND_TEMPLATE_DEVICE_SUCCESS";
export const SUBMISSION_MAKE_TEMPLATE_MODAL_CLOSE =
  "SUBMISSION_MAKE_TEMPLATE_MODAL_CLOSE";
export const SUBMISSION_MAKE_TEMPLATE_MODAL_OPEN =
  "SUBMISSION_MAKE_TEMPLATE_MODAL_OPEN";
export const SUBMISSION_MAKE_TEMPLATE_SET_DEVICE =
  "SUBMISSION_MAKE_TEMPLATE_SET_DEVICE";
export const SUBMISSION_FORM_SOURCE_FETCH_REQUEST =
  "SUBMISSION_FORM_SOURCE_FETCH_REQUEST";
export const SUBMISSION_FORM_SOURCE_FETCH_SUCCESS =
  "SUBMISSION_FORM_SOURCE_FETCH_SUCCESS";
export const SUBMISSION_FORM_SOURCE_FETCH_ERROR =
  "SUBMISSION_FORM_SOURCE_FETCH_ERROR";

export const SUBMISSION_DATA_FETCH_REQUEST = "SUBMISSION_DATA_FETCH_REQUEST";
export const SUBMISSION_DATA_FETCH_SUCCESS = "SUBMISSION_DATA_FETCH_SUCCESS";
export const SUBMISSION_DATA_FETCH_ERROR = "SUBMISSION_DATA_FETCH_ERROR";

export const SUBMISSION_ERROR_FILTER = "SUBMISSION_ERROR_FILTER";
export const SUBMISSION_SEARCH_FILTER = "SUBMISSION_SEARCH_FILTER";
export const SUBMISSION_SERVER_SEARCH_FILTER =
  "SUBMISSION_SERVER_SEARCH_FILTER";
export const SUBMISSION_SERVER_SEARCH_FILTER_SUCCESS =
  "SUBMISSION_SERVER_SEARCH_FILTER_SUCCESS";
export const SUBMISSION_RANGE_FILTER = "SUBMISSION_RANGE_FILTER";

export const SUBMISSION_DETAILS_MODAL_OPEN = "SUBMISSION_DETAILS_MODAL_OPEN";
export const SUBMISSION_DETAILS_MODAL_CLOSE = "SUBMISSION_DETAILS_MODAL_CLOSE";
export const SUBMISSION_DETAILS_MODAL_SET_INDEX =
  "SUBMISSION_DETAILS_MODAL_SET_INDEX";
export const SUBMISSION_DETAILS_MODAL_SET_DATA =
  "SUBMISSION_DETAILS_MODAL_SET_DATA";

export const SUBMISSION_PROCESS_LOG_FETCH_REQUEST =
  "SUBMISSION_PROCESS_LOG_FETCH_REQUEST";
export const SUBMISSION_PROCESS_LOG_FETCH_SUCCESS =
  "SUBMISSION_PROCESS_LOG_SUCCESS";
export const SUBMISSION_PROCESS_LOG_FETCH_ERROR =
  "SUBMISSION_PROCESS_LOG_FETCH_ERROR";

export const SUBMISSION_PROCESS_LOG_UPDATE_STATUS =
  "SUBMISSION_PROCESS_LOG_UPDATE_STATUS";

export const SUBMISSION_DETAIL_MODAL_ADD_CHECKED_INDEX =
  "SUBMISSION_DETAIL_MODAL_ADD_CHECKED_INDEX";
export const SUBMISSION_DETAIL_MODAL_REMOVE_CHECKED_INDEX =
  "SUBMISSION_DETAIL_MODAL_REMOVE_CHECKED_INDEX";

export const SUBMISSION_PROCESS_LOG_SET_ACTION =
  "SUBMISSION_PROCESS_LOG_SET_ACTION";
export const SUBMISSION_PROCESS_LOG_TOGGLE_SELECT_ALL =
  "SUBMISSION_PROCESS_LOG_TOGGLE_SELECT_ALL";
export const SUBMISSION_PROCESS_LOG_UPDATE_ROW =
  "SUBMISSION_PROCESS_LOG_UPDATE_ROW";
export const SUBMISSION_PROCESS_LOG_UPDATE_SUCCESS =
  "SUBMISSION_PROCESS_LOG_UPDATE_SUCCESS";
export const SUBMISSION_PROCESS_LOG_INVALIDATE =
  "SUBMISSION_PROCESS_LOG_INVALIDATE";

export const SUBMISSION_OPEN_JSON_MODAL = "SUBMISSION_OPEN_JSON_MODAL";
export const SUBMISSION_CLOSE_JSON_MODAL = "SUBMISSION_CLOSE_JSON_MODAL";

export const SUBMISSION_FORM_DATA_FETCH_SUCCESS =
  "SUBMISSION_FORM_DATA_FETCH_SUCCESS";
export const SUBMISSION_FORM_DATA_FETCH_REQUEST =
  "SUBMISSION_FORM_DATA_FETCH_REQUEST";

export const SUBMISSION_FORM_DATA_MODAL_OPEN =
  "SUBMISSION_FORM_DATA_MODAL_OPEN";
export const SUBMISSION_FORM_DATA_MODAL_CLOSE =
  "SUBMISSION_FORM_DATA_MODAL_CLOSE";

export const SUBMISSION_CHANGE_MODAL_OPEN = "SUBMISSION_CHANGE_MODAL_OPEN";
export const SUBMISSION_CHANGE_MODAL_CLOSE = "SUBMISSION_CHANGE_MODAL_CLOSE";

export const SUBMISSION_RECALL_MODAL_OPEN = "SUBMISSION_RECALL_MODAL_OPEN";
export const SUBMISSION_RECALL_MODAL_CLOSE = "SUBMISSION_RECALL_MODAL_CLOSE";
export const SUBMISSION_RECALL_CONFIRM_MODAL_CLOSE =
  "SUBMISSION_RECALL_CONFIRM_MODAL_CLOSE";
export const SUBMISSION_RECALL_SET_DEVICE = "SUBMISSION_RECALL_SET_DEVICE";
export const SUBMISSION_RECALL_DEVICE_REQUEST =
  "SUBMISSION_RECALL_DEVICE_REQUEST";
export const SUBMISSION_RECALL_DEVICE_SUCCESS =
  "SUBMISSION_RECALL_DEVICE_SUCCESS";
export const SUBMISSION_RECALL_DEVICE_ERROR = "SUBMISSION_RECALL_DEVICE_ERROR";

export const SUBMISSION_SET_CHANGE_ORDER_SUBMISSION_ID =
  "SUBMISSION_SET_CHANGE_ORDER_SUBMISSION_ID";

export const SUBMISSION_DEVICES_FETCH_SUCCESS =
  "SUBMISSION_DEVICES_FETCH_SUCCESS";
export const SUBMISSION_DEVICES_FETCH_ERROR = "SUBMISSION_DEVICES_FETCH_ERROR";
export const SUBMISSION_DEVICES_FETCH_REQUEST =
  "SUBMISSION_DEVICES_FETCH_REQUEST";

export const SUBMISSION_DELETE_CONFIRM_MODAL_OPEN =
  "SUBMISSION_DELETE_CONFIRM_MODAL_OPEN";
export const SUBMISSION_DELETE_CONFIRM_MODAL_CLOSE =
  "SUBMISSION_DELETE_CONFIRM_MODAL_CLOSE";

export const SUBMISSION_PROCESS_LOG_UPDATE_REQUEST =
  "SUBMISSION_PROCESS_LOG_UPDATE_REQUEST";
export const SUBMISSION_UPDATE_STORED_PROCESS_LOG =
  "SUBMISSION_UPDATE_STORED_PROCESS_LOG";
export const SUBMISSION_UPDATE_STORED_PROCESS_FORM =
  "SUBMISSION_UPDATE_STORED_PROCESS_FORM";
export const SUBMISSION_SET_FORM_DATA_SEARCH_TEXT =
  "SUBMISSION_SET_FORM_DATA_SEARCH_TEXT";
export const SUBMISSION_CHANGE_JSON_LEVELS_VIEW =
  "SUBMISSION_CHANGE_JSON_LEVELS_VIEW";

export const SUBMISSION_UPDATING_ROW = "SUBMISSION_UPDATING_ROW";
export const SUBMISSION_SUCCESS_ROW = "SUBMISSION_SUCCESS_ROW";
export const SUBMISSION_UPDATE_ROW = "SUBMISSION_UPDATE_ROW";

export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";
